import React, { useEffect, useState } from "react";
import "../../../Styles/index.scss";
import {
  CollapseClose,
  CollapseCloseWhiteIcon,
  CollapseOpen,
  CollapseOpenWhiteIcon,
} from "../../../../../assets/images";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import GstTableHeader from "../../../common/GstTableHeader";
import GstrOneInvoiceData from "../GstrOneInvoiceData";

type AppProps = {
  headers: TableHeadersType[];
  singleHeader?: TableHeadersType[];
  data: any;
  settingData: Function;
  type: string;
  handleGstrOneInvoiceList?: (id: string, data: string) => void;
  showhsnCount?: boolean | undefined;
  setShowhsnCount?: any;
};

const GstrOneAccordian = ({
  headers,
  data,
  settingData,
  singleHeader,
  type,
  handleGstrOneInvoiceList,
  showhsnCount,
  setShowhsnCount,
}: AppProps) => {
  const [iterableGstrOneData, setIterableGstrOneData] = useState<any>([]);

  useEffect(() => {
    if (data?.length) {
      let finalData: any[] = JSON.parse(JSON.stringify(data));
      setIterableGstrOneData([...finalData]);
    }
  }, [data]);
  const handleSourceInvoice = (id: string, data: any) => {
    handleGstrOneInvoiceList && handleGstrOneInvoiceList(id, data?.id);
    let newInvoiceData = JSON.parse(JSON.stringify(iterableGstrOneData));

    newInvoiceData?.map((item: any) => {
      if (
        item?.id == "4aTaxable" ||
        item?.id == "4bTaxable" ||
        item?.id == "5ATaxable" ||
        item?.id == "5BTaxable" ||
        item?.id == "12HSN" ||
        item?.id == "13Documents" ||
        item?.id == "7Taxable"
      ) {
        if (item?.id == id) {
          item.data = { ...item?.data, src: !item?.data?.src };
        }
      } else if (item?.id == id && item?.id == "9BCredit/Debit") {
        let singleItemData = structuredClone(item?.data);
        let finalObj: any = {};
        for (let key in singleItemData) {
          let finalData = singleItemData[key]?.map((singleItem: any) => {
            if (singleItem?.id == data?.id) {
              return { ...singleItem, src: !singleItem?.src };
            } else {
              return { ...singleItem };
            }
          });
          finalObj[key] = finalData;
        }
        if (item) {
          item.data = finalObj;
        }
      } else {
        if (item?.id == id) {
          let singleItemData = structuredClone(item?.data);

          let newSingleInvoiceData =
            Array.isArray(singleItemData) &&
            singleItemData?.map((singleItem: any) => {
              if (singleItem?.id == data?.id) {
                return { ...singleItem, src: !singleItem?.src };
              } else {
                return { ...singleItem };
              }
            });
          if (Array.isArray(newSingleInvoiceData)) {
            item.data = [...newSingleInvoiceData];
          }
        }
      }
    });

    settingData([...newInvoiceData]);
  };

  function handleData(item: any) {
    let finalData = (
      <div className="gstr">
        <table className="table table-bordered">
          <thead className="sticky-table-header  thead-light">
            <GstTableHeader tableHeader={headers} type={"gstrForms"} />
          </thead>

          <tbody>{renderTableData(item)}</tbody>
        </table>
      </div>
    );

    return finalData;
  }

  function renderTableRowData(itemName: string, data: any, header: any) {
    if (
      header.value === "description" &&
      data?.withBackground &&
      data?.fullLength
    ) {
      return (
        <td
          className="data_inside_table"
          colSpan={headers.length}
          style={{ backgroundColor: "#f3f6f8" }}
        >
          {data?.description}
        </td>
      );
    } else if (
      header.value === "description" &&
      data?.fullLength &&
      data.noBorder
    ) {
      return (
        <td
          className="data_inside_table"
          colSpan={headers.length}
          style={{ border: "0" }}
        >
          {data?.description}
        </td>
      );
    } else if (
      header.value === "description" &&
      !data?.withBackground &&
      data?.fullLength
    ) {
      return (
        <td className="data_inside_table" colSpan={headers.length}>
          {data?.description}
        </td>
      );
    } else if (header.value === "description") {
      return (
        <td className="gstr_description">
          <span>{data?.description}</span>
          {data?.isSource ? (
            <span
              style={{
                color: "red",
                marginLeft: "12px",
                marginTop: "1px",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={() => handleSourceInvoice(itemName, data)}
            >
              View Source
            </span>
          ) : null}
        </td>
      );
    } else if (header.value === "hsn_count") {
      return (
        <td className="data_inside_table">
          {itemName === "12HSN" && data?.hsn_count
            ? +data?.hsn_count?.toFixed(2)
            : data?.total_count
            ? +data?.total_count?.toFixed(2)
            : 0}
          {itemName === "12HSN" && (
            <span
              style={{
                color: "red",
                marginLeft: "12px",
                marginTop: "1px",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={() => setShowhsnCount(!showhsnCount)}
            >
              View Records
            </span>
          )}
        </td>
      );
    } else if (header.value === "document_type") {
      return <td className="data_inside_table">{""}</td>;
    } else if (header.value === "value") {
      return (
        <td className="data_inside_table">
          {data?.total_taxable_value
            ? data?.total_taxable_value?.toFixed(2)
            : 0}
        </td>
      );
    } else if (header.value === "integrated_tax") {
      return (
        <td
          className="data_inside_table"
          style={
            (itemName == "6AExports" && data?.description == "EXPWOP") ||
            (itemName == "6BSupplies" && data?.description == "SEZWOP") ||
            itemName == "8Nil" ||
            (data?.key == "9BCredit/Debit(unregistered)" &&
              data?.description == "- EXPWOP")
              ? { backgroundColor: "#e2e4ed", color: "#e2e4ed" }
              : {}
          }
        >
          {data?.total_igst_amount ? data?.total_igst_amount?.toFixed(2) : 0}
        </td>
      );
    } else if (header.value === "central_tax") {
      return (
        <td
          className="data_inside_table"
          style={
            itemName == "6AExports" ||
            itemName == "6BSupplies" ||
            itemName == "8Nil" ||
            itemName == "5ATaxable" ||
            data?.key == "9BCredit/Debit(unregistered)" ||
            data?.key == "9BCredit/Debit(6B-SEZWP/SEZWOP)"
              ? { backgroundColor: "#e2e4ed", color: "#e2e4ed" }
              : {}
          }
        >
          {data?.total_cgst_amount ? data?.total_cgst_amount?.toFixed(2) : 0}
        </td>
      );
    } else if (header.value === "state_ut_tax") {
      return (
        <td
          className="data_inside_table"
          style={
            itemName == "6AExports" ||
            itemName == "6BSupplies" ||
            itemName == "8Nil" ||
            itemName == "5ATaxable" ||
            data?.key == "9BCredit/Debit(unregistered)" ||
            data?.key == "9BCredit/Debit(6B-SEZWP/SEZWOP)"
              ? { backgroundColor: "#e2e4ed", color: "#e2e4ed" }
              : {}
          }
        >
          {data?.total_sgst_amount ? data?.total_sgst_amount?.toFixed(2) : 0}
        </td>
      );
    } else if (header.value === "cess") {
      return (
        <td
          className="data_inside_table"
          style={
            (itemName == "6AExports" && data?.description == "EXPWOP") ||
            itemName == "8Nil" ||
            (itemName == "6BSupplies" && data?.description == "SEZWOP") ||
            (data?.key == "9BCredit/Debit(unregistered)" &&
              data?.description == "- EXPWOP")
              ? { backgroundColor: "#e2e4ed", color: "#e2e4ed" }
              : {}
          }
        >
          {""}
        </td>
      );
    }
  }

  function renderTableData(item: any) {
    if (Array.isArray(item?.data)) {
      const finalTableData =
        item?.data?.length &&
        item?.data?.map((dataItem: any, i: any) => {
          return (
            <>
              <tr style={{ backgroundColor: "white" }}>
                {headers?.length &&
                  headers?.map((header: TableHeadersType) => {
                    if (type === "gstrone") {
                      return renderTableRowData(item?.id, dataItem, header);
                    }
                  })}
              </tr>

              {dataItem?.src && (
                <GstrOneInvoiceData gstrInvoiceData={dataItem?.srcData} />
              )}
            </>
          );
        });
      return finalTableData;
    }
    if (item?.id === "9BCredit/Debit") {
      const finalTableData =
        [...item.data.registered, ...item.data.unRegistered].length > 0 &&
        [...item.data.registered, ...item.data.unRegistered]?.map(
          (dataItem: any, i: any) => {
            let ninebHeaders = dataItem?.fullLength ? singleHeader : headers;

            return (
              <>
                <tr
                  style={
                    dataItem?.noBorder
                      ? { backgroundColor: "white", border: "0" }
                      : { backgroundColor: "white" }
                  }
                >
                  {ninebHeaders?.length &&
                    ninebHeaders?.map((header: TableHeadersType) => {
                      if (type === "gstrone") {
                        return renderTableRowData(item?.id, dataItem, header);
                      }
                    })}
                </tr>
                {dataItem?.src && (
                  <GstrOneInvoiceData gstrInvoiceData={dataItem?.srcData} />
                )}
              </>
            );
          }
        );
      return finalTableData;
    } else {
      let finalData = (
        <>
          <tr style={{ backgroundColor: "white" }}>
            {headers?.length &&
              headers?.map((header: TableHeadersType) => {
                if (type === "gstrone") {
                  return renderTableRowData(item?.id, item?.data, header);
                }
              })}
          </tr>
          {item?.data?.src && (
            <GstrOneInvoiceData gstrInvoiceData={item?.data?.srcData} />
          )}
        </>
      );
      return finalData;
    }
  }

  const handleToggleAccordianClick = (id: any) => {
    iterableGstrOneData?.map((elem: any) => {
      if (elem.id === id) {
        elem.isOpen = !elem.isOpen;
      }
    });
    settingData([...iterableGstrOneData]);
  };

  return (
    <>
      {iterableGstrOneData?.map((item: any) => {
        return (
          <div className="col-md-12">
            <>
              <div className="accordian">
                <>
                  {item.isOpen ? (
                    <img
                      width="20px"
                      onClick={() => handleToggleAccordianClick(item.id)}
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseOpenWhiteIcon : CollapseOpen}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  ) : (
                    <img
                      width="20px"
                      onClick={() => handleToggleAccordianClick(item.id)}
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseCloseWhiteIcon : CollapseClose}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  )}
                </>

                {item?.header}
              </div>

              {item.isOpen && <div>{handleData(item)}</div>}
            </>
          </div>
        );
      })}
    </>
  );
};

export default GstrOneAccordian;
